<template>
  <v-row justify="center">
    <v-dialog
      overlay-opacity="0.8"
      overlay-color="primary"
      :value="withdrawDialog"
      persistent
      max-width="800px"
      :content-class="
        withdrawDialog ? 'elevation-0 d-flex flex-column align-center' : ''
      "
      transition="scroll-y-transition"
    >
      <v-card flat color="transparent" class="d-flex align-center flex-column">
        <div class="text-h3 secondary--text text-center font-weight-bold mb-5">
          Withdraw From Your Wallet
        </div>
        <v-card max-width="500px">
          <v-card-title>
            <!-- <span class="headline">User Profile</span> -->
          </v-card-title>
          <v-card-text>
            <v-container>
              <div class="d-flex justify-end mt-n4 mr-n2 mb-4">
                <v-btn
                  icon
                  color="secondary"
                  @click="$emit('toggleDialog', false)"
                >
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
              </div>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="withdrawAmount"
                    outlined
                    label="Amount*"
                    required
                    hint="Minimum of 2,000 Naira"
                    type="number"
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12">
                  <v-select
                    :disabled="withdrawAmount < 2000"
                    :items="bankOptions"
                    :loading="isLoadingAccounts"
                    item-text="accountnumber"
                    label="Select A Bank Account*"
                    return-object
                    v-model="selectedBank"
                    outlined
                  ></v-select>
                </v-col>

                <v-col cols="12" v-if="sentOTP">
                  <v-text-field
                    :disabled="!selectedBank"
                    v-model="otp"
                    outlined
                    label="Enter OTP"
                    required
                    type="number"
                    
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="sentOTP" depressed
              color="primary"
              class="text-none"
              @click="initiateWithdrawal"
              :disabled="withdrawAmount < 2000"
              >Proceed</v-btn
            >
            <v-btn v-else depressed
              color="primary"
              class="text-none"
              :loading="requestingOTP"
              @click="requestOTP"
              :disabled="withdrawAmount < 2000 || !selectedBank"
              >Request OTP</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { BankAccountService, UserService } from "@/services/index.js";

export default {
  props: {
    withdrawDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      withdrawAmount: 0,
      bankOptions: [],
      requestingOTP: false,
      sentOTP: false,
      isLoadingAccounts: false,
      selectedBank: null,
      otp: "",
    };
  },
  methods: {
    async initiateWithdrawal() {
        try {
            const { message } = await BankAccountService.withdraw({
             bankaccountid: this.selectedBank.id,
             amount: this.withdrawAmount,
             otp: this.otp
           });
   
           this.$store.commit("openSnackbar",
             message
           );
             this.$emit('toggleDialog', false);
        } catch (error) {
            // throw error;
        }
    },
     async requestOTP() {
      this.requestingOTP = true;
      this.sentOTP = false;
      try {
        const { message } = await UserService.requestOTP("withdraw");
        // console.log(res)
        this.$store.commit('openSnackbar', message);
        this.sentOTP = true;
        this.requestingOTP = false;
      } catch (err) {
        this.requestingOTP = false;
        // throw err;
      }
    },
    async getBankAccounts() {
      try {
        this.isLoadingAccounts = true;
        const { data: accounts } = await BankAccountService.getAll();
        // let res = await BankAccountService.getAll();

        this.bankOptions = accounts;
        // console.log(accounts)
        this.isLoadingAccounts = false;
      } catch (error) {
        this.isLoadingAccounts = false;

        // throw error;
      }
    },
  },
  mounted(){
      this.getBankAccounts()
  },
  
};
</script>
